import React from "react";
import { Container } from "./style";
const Com1 = ({ t }) => {
  return (
    <Container>
      <div>{t("1-1")}</div>
      <div>{t("1-2")}</div>
    </Container>
  );
};

export default Com1;
